import React, { Component } from 'react';
import styles from './styles';
import { css } from 'aphrodite';

class Button extends Component {

    render() {
        const {
            text,
            link,
            isTransparent,
            isBlock,
            isPrimary,
            onClick,
            addIcon,
            isActive,
            inactiveText,
            isCalculationButton,
            isExternalLink,
            dataLayer,
            typeOfGrout,
            trackingEventAction,
            isTracked,
            context,
        } = this.props;

        var isInt = context === 'int';
        var isQual = context === 'qual';
        var isProd = context === 'prod';
        var islocal = context === 'local';

        return (
            <div>
                <a
                    href={link}
                    target={isExternalLink ? "_blank" : ""}
                    className={css(
                        styles.button,
                        isBlock && styles.block,
                        isTransparent && styles.transparent,
                        isPrimary && styles.primary,
                        addIcon && styles.addIcon,
                        isInt && styles.addIconInt,
                        isQual && styles.addIconQual,
                        isProd && styles.addIconProd,
                        islocal && styles.addIconlocal,
                        !isActive && styles.disabled,
                    )}
                    onClick={(e) => {
                        if (isTracked && dataLayer !== null) {
                            dataLayer.push({
                                'event' : 'eventGA',
                                'eventCategory': 'Grout calculator',
                                'eventAction': trackingEventAction,
                                'eventLabel': typeOfGrout
                            });
                            // console.log(dataLayer)
                        }
                        onClick && onClick(e)
                    }}
                >
                    <span>{text}</span>
                </a>
                {
                    isActive ?
                    <div></div>
                    :
                    <div className={css(styles.inactiveText)}>
                        <span>{inactiveText}</span>
                    </div>
                }
            </div>
        );
    }
}

Button.defaultProps = {
    isTransparent: false,
    addIcon: false,
    isActive: true,
    isExternalLink: false,
}

export default Button;